<template>
  <div class="datagrid-item">
    <div class="datagrid-title">Автоматическое удаление</div>
    <div class="datagrid-content mt-1"><b>{{ getVal() }}</b></div>
  </div>
</template>

<script>
import {defineComponent} from "vue"

export default defineComponent({
  name: "AutoDeleteDate",
  props: {
    data: {
      type: String,
      require: true,
    },
  },
  setup(props) {
    function getVal() {
      if (props.data["auto_delete_date"] === null) {
        return "Нет"
      }

      return props.data["auto_delete_date"]
    }

    return {
      getVal,
    }
  }
})
</script>

<style scoped>

</style>
